export default "__VITE_PUBLIC_ASSET__b463b63a__"